import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { FacilityPatientSearchResultItem } from '../fp-search/FacilityPatientSearchResultItem';
import { FpSearchParametersDto } from 'webcommon/shared';
import { FacilityPatientRepository } from 'webcommon/webapi';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FpSearchService {
  static readonly ajsFactoryName = 'FpSearchService';

  constructor(
    private facilityPatientRepository: FacilityPatientRepository,
  ) { }
  public lastSearch: FpSearchParametersDto;
  public lastSearchResults: FacilityPatientSearchResultItem[] = [];

  clearLastSearch()
  {
      this.lastSearchResults = [];
      this.lastSearch = {
        FirstName: null,
        LastName: null,
        PhoneNumber: null,
        SocialSecurityNumber: null,
        ExternalId: null,
        DateOfBirth: null,
        FromDate: null,
        ToDate: null,
        ServiceSite: null,
        PatientPrograms: [],
      };
  }
  getPatients(userQuery: FpSearchParametersDto): Observable<FacilityPatientSearchResultItem[]> {
    return this.facilityPatientRepository.getPatients(userQuery).pipe(
      tap(() => {
        this.lastSearch = userQuery;
      }),
      map((data) => {
        return data.map(item => {
          return {
            ...item,
            Downloading: false,
            Downloaded: false
          };
        });
      }),
      tap((data) => {
        this.lastSearchResults = data;
      })
    );
  }
}
